var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9997 121C94.1367 121 120.999 94.1367 120.999 60.9997C120.999 27.8628 94.1367 1 60.9997 1C27.8628 1 1 27.8628 1 60.9997C1 94.1367 27.8628 121 60.9997 121Z",
    stroke: "#0F0F0F",
    strokeWidth: 0.599997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0041 98.4983C90.8081 98.4983 114.969 93.1725 114.969 86.6027C114.969 80.0329 90.8081 74.707 61.0041 74.707C31.2 74.707 7.03906 80.0329 7.03906 86.6027C7.03906 93.1725 31.2 98.4983 61.0041 98.4983Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.599997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3717 92.1658C79.8364 92.1658 95.6156 89.3987 95.6156 85.9852C95.6156 82.5718 79.8364 79.8047 60.3717 79.8047C40.9071 79.8047 25.1279 82.5718 25.1279 85.9852C25.1279 89.3987 40.9071 92.1658 60.3717 92.1658Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0088 85.4083C41.0282 85.4083 24.834 69.214 24.834 49.2334C24.834 29.2529 41.0282 13.0586 61.0088 13.0586C80.9894 13.0586 97.1836 29.2529 97.1836 49.2334C97.1836 69.214 80.9894 85.4083 61.0088 85.4083Z",
    fill: "#2BB673",
    stroke: "#0F0F0F",
    strokeWidth: 0.841275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0861 41.1934L56.9889 61.2905L44.9307 49.2322",
    stroke: "white",
    strokeWidth: 4.79998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.721 27.8201C107.329 27.2649 106.925 26.7264 106.516 26.1936C118.344 51.3365 114.457 92.2562 94.0311 106.816C69.8192 124.073 40.3016 114.657 23.0443 90.4446C5.78691 66.2327 6.37021 36.3282 27.7386 14.4102C1.95071 32.7948 -4.05599 68.6051 14.3287 94.393C32.7133 120.181 68.5236 126.188 94.3115 107.803C120.099 89.4183 126.106 53.608 107.721 27.8201Z",
    fill: "#2BB673"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0047 98.4969C33.3324 98.4969 10.5282 93.9035 7.40991 87.9922H7.4043C17.2809 107.571 37.5724 120.998 61.0047 120.998C84.381 120.998 104.639 107.628 114.538 88.1156C111.162 93.9709 88.4808 98.4969 61.0047 98.4969Z",
    fill: "#2BB673",
    stroke: "#0F0F0F",
    strokeWidth: 0.599997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.261 93.4052C102.334 98.8454 98.5873 103.444 94.0052 106.709C71.7506 122.569 45.0149 115.895 27.4379 95.9122C21.2853 94.8353 16.2321 93.4613 12.6875 91.8965C13.2035 92.6985 13.7419 93.4949 14.3028 94.2857C32.6874 120.074 68.4977 126.08 94.2856 107.696C100.449 103.299 105.48 97.9088 109.322 91.8965C108.133 92.4237 106.776 92.9284 105.256 93.4052H105.261Z",
    fill: "#0F0F0F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.539 88.1162C114.539 88.1162 114.539 88.1108 114.539 88.1055C114.539 88.1055 114.539 88.1108 114.539 88.1162Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.599997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.a22c51ab3a82c754928810a6475de0c8.svg";
export { ForwardRef as ReactComponent };